import type BaseModel from "../../models/BaseModel";
import type BaseObject from "../../models/BaseObject";

/** Limits selection-based pinning to descendants of this navigator's normal subtree. */
export function canPinNavigatorSelection(object: BaseModel | undefined, root: BaseModel, excluded?: BaseModel | readonly BaseModel[]): boolean {
  if (!object || object.isDeleted || object === root) return false;
  const visited = new Set<BaseObject>();
  for (let parent: BaseObject | undefined = object; parent && !visited.has(parent); parent = parent.parent) {
    if ((Array.isArray(excluded) ? excluded.includes(parent) : parent === excluded) || parent.isDeleted) return false;
    if (parent === root) return true;
    visited.add(parent);
  }
  return false;
}

/** Resolves the application's object drag payload without copying or moving the object. */
export function navigatorPinDropObject(payload: string, resolve: (id: string) => BaseModel | undefined): BaseModel | undefined {
  try {
    const data: unknown = JSON.parse(payload);
    if (!data || typeof data !== "object" || !("id" in data) || typeof data.id !== "string") return;
    const object = resolve(data.id);
    return object && !object.isDeleted ? object : undefined;
  } catch {
    return undefined;
  }
}
